import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DateMaskDirective } from './date-mask.directive';
import { MaxNumberDirective } from './max-number.directive';
import { DesabilitaPreenchimentoDirective } from './desabilita-preenchimento.directive';
import { ResourceDirective } from './resource.directive';
import { ResponsavelContratanteDirective } from './responsavel-contratante.directive';
import { ResponsavelIncentivadaDirective } from './responsavel-incentivada.directive';
import { ResponsavelPreenchimentoDirective } from './responsavel-preenchimento.directive';
import { ScrollToDirective } from './scroll-to.directive';
import { VisualizaPreenchimentoDirective } from './visualiza-preenchimento.directive';
import { MatSelectCheckboxChangesDirective } from './select-multiple-change.directive';
import { CurrencyPasteMaxLengthDirective } from './currency-paste-max-length.directive';

@NgModule({
    declarations: [
        MaxNumberDirective,
        DateMaskDirective,
        ResourceDirective,
        ScrollToDirective,
        VisualizaPreenchimentoDirective,
        MatSelectCheckboxChangesDirective,
        ResponsavelPreenchimentoDirective,
        DesabilitaPreenchimentoDirective,
        ResponsavelContratanteDirective,
        ResponsavelIncentivadaDirective,
        CurrencyPasteMaxLengthDirective
    ],
    exports: [
        MaxNumberDirective,
        MatMomentDateModule,
        DateMaskDirective,
        ResourceDirective,
        ScrollToDirective,
        MatSelectCheckboxChangesDirective,
        VisualizaPreenchimentoDirective,
        ResponsavelPreenchimentoDirective,
        DesabilitaPreenchimentoDirective,
        ResponsavelContratanteDirective,
        ResponsavelIncentivadaDirective,
        CurrencyPasteMaxLengthDirective
    ],
  imports: [CommonModule, MatMomentDateModule],
  providers: [DecimalPipe]
})
export class DirectiveModule {
}
